/**
 * Compares two semantic version strings (e.g., "1.2.3").
 * @param {string} versionA - The first version string to compare (e.g., "1.2.3").
 * @param {string} versionB - The second version string to compare (e.g., "1.2.4").
 * @returns {number} 0 if equal, 1 if versionA > versionB, -1 if versionA < versionB.
 */
const compareVersions = (versionA, versionB) => {
  if (versionA === versionB) {
    return 0
  }

  const splitA = versionA.split('.')
  const splitB = versionB.split('.')

  const maxLength = Math.max(splitA.length, splitB.length)

  for (let i = 0; i < maxLength; i++) {
    const valueA = splitA[i] || '0'
    const valueB = splitB[i] || '0'
    if (parseInt(valueA) > parseInt(valueB)) {
      return 1
    }

    if (parseInt(valueA) < parseInt(valueB)) {
      return -1
    }
  }

  return 0
}

export default compareVersions
